// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-label[data-v-4f4050e0] {\n  font-size: 12px;\n  line-height: 16px;\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
